import React, { useMemo, useState } from 'react';
import { Menu, X } from 'lucide-react';
import { useLocation, useNavigate } from 'react-router-dom';
import ProfileTab from './ProfileTab';
import AddressBook from './AddressBook';
import Footer from '../Footer/Footer';
import './AccountPage.css';

const TABS = [
    { id: 'profile', label: 'Личные данные' },
    { id: 'addresses', label: 'Адреса' },
    { id: 'orders', label: 'Заказы' },
];

const AccountPage = ({ data }) => {
    const location = useLocation();
    const navigate = useNavigate();
    const activeTab = location.hash.replace('#', '') || 'profile';
    const [menuOpen, setMenuOpen] = useState(false);
    const addresses = data?.Addresses?.$values || [];

    const activeTabLabel = useMemo(
        () => TABS.find((tab) => tab.id === activeTab)?.label || 'Личный кабинет',
        [activeTab]
    );

    const handleTabChange = (tabId) => {
        navigate(`#${tabId}`);
        setMenuOpen(false);
    };

    return (
        <>
            <section className="account-page">
                <div className="account-shell">
                    <div className="account-hero">
                        <div>
                            <div className="account-eyebrow">Account</div>
                            <h1 className="account-title">Личный кабинет</h1>
                            <p className="account-description">
                                Управляйте профилем, адресами и параметрами безопасности в едином кабинете.
                            </p>
                        </div>

                        <div className="account-meta">
                            <span>{data?.Email || 'No email provided'}</span>
                            <span>{activeTabLabel}</span>
                        </div>
                    </div>

                    <div className="account-tabs-toolbar">
                        <button
                            className="account-button--ghost account-mobile-toggle"
                            onClick={() => setMenuOpen((prev) => !prev)}
                            type="button"
                        >
                            {menuOpen ? <X size={16} /> : <Menu size={16} />}
                            <span>{menuOpen ? 'Закрыть меню' : 'Разделы'}</span>
                        </button>

                        <div className={`account-tabs ${menuOpen ? 'is-open' : ''}`}>
                            {TABS.map((tab) => (
                                <button
                                    key={tab.id}
                                    className={`account-tab ${activeTab === tab.id ? 'is-active' : ''}`}
                                    onClick={() => handleTabChange(tab.id)}
                                    type="button"
                                >
                                    {tab.label}
                                </button>
                            ))}
                        </div>
                    </div>

                    <div className="account-content">
                        {activeTab === 'profile' && <ProfileTab data={data} />}

                        {activeTab === 'addresses' && <AddressBook data={addresses} />}

                        {activeTab === 'orders' && (
                            <section className="account-section">
                                <div className="account-section__header">
                                    <h2 className="account-section__title">Заказы</h2>
                                    <p className="account-section__description">
                                        История покупок и статусы доставки будут отображаться здесь.
                                    </p>
                                </div>

                                <div className="account-panel">
                                    <p className="account-empty">У вас пока нет заказов.</p>
                                </div>
                            </section>
                        )}
                    </div>
                </div>
            </section>

            <Footer />
        </>
    );
};

export default AccountPage;
